var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCheckmarkDefault(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Checkmark/M/Default"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.86,18 C9.58283494,17.9991084 9.31847178,17.8832232 9.13,17.68 L4.27,12.51 C3.89168495,12.1068321 3.91183213,11.4733151 4.315,11.095 C4.71816787,10.7166849 5.35168495,10.7368321 5.73,11.14 L9.85,15.53 L18.26,6.33 C18.4925515,6.04041485 18.8664394,5.90356737 19.2309842,5.97460808 C19.5955291,6.0456488 19.8906733,6.31287396 19.9974716,6.66858993 C20.10427,7.02430591 20.0051278,7.40990961 19.74,7.67 L10.6,17.67 C10.4132861,17.8769226 10.1486881,17.9965354 9.87,18 L9.86,18 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckmarkDefault);
export default __webpack_public_path__ + "static/media/icon_checkmark_default.1606e8c1.svg";
export { ForwardRef as ReactComponent };